"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var core_1 = require("@angular/core");
var type_configuration_service_1 = require("../../../../shared/services/api/type-configuration.service");
var idm_portfolio_control_1 = require("@synisys/idm-portfolio-control");
var operators_1 = require("rxjs/operators");
var portfolio_column_model_1 = require("@synisys/idm-portfolio-control/app/controls/model/portfolio.column.model");
var column_type_1 = require("@synisys/idm-portfolio-control/app/controls/model/column-type");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var custom_aggregate_functions_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-functions-provider.service");
var custom_aggregate_filtering_provider_service_1 = require("../../../../shared/services/api/summary-pages/custom-aggregate/custom-aggregate-filtering-provider.service");
var overview_field_type_1 = require("../model/overview-field-type");
var base_portfolio_constructed_portfolio_model_1 = require("../model/base-portfolio-constructed-portfolio.model");
var ReplaySubject_1 = require("rxjs/ReplaySubject");
var of_1 = require("rxjs/observable/of");
var root_category_provider_service_1 = require("../../../../shared/services/api/root-category-provider.service");
var base_portfolio_custom_filter_properties_service_1 = require("../../../../shared/services/api/summary-pages/base-portfolio-custom-filter-properties.service");
var portfolio_definition_custom_values_service_1 = require("../../../../shared/services/api/portfolio-definition-custom-values.service");
var zip_1 = require("rxjs/observable/zip");
var BasePortfolioHelperService = /** @class */ (function () {
    function BasePortfolioHelperService(portfolioDefinitionCustomValuesService, customAggregateFunctionsProviderService, customAggregateFilteringProviderService, basePortfolioCustomFilterPropertiesService, rootCategoryProviderService, typeConfigurationService, kbService) {
        this.portfolioDefinitionCustomValuesService = portfolioDefinitionCustomValuesService;
        this.customAggregateFunctionsProviderService = customAggregateFunctionsProviderService;
        this.customAggregateFilteringProviderService = customAggregateFilteringProviderService;
        this.basePortfolioCustomFilterPropertiesService = basePortfolioCustomFilterPropertiesService;
        this.rootCategoryProviderService = rootCategoryProviderService;
        this.typeConfigurationService = typeConfigurationService;
        this.kbService = kbService;
    }
    BasePortfolioHelperService_1 = BasePortfolioHelperService;
    /**
     * Constructs initial additional fields to be loaded for portfolio.
     * @param config Current category's Base Portfolio's configuration
     * @param typeConfig Type Configuration of current category
     */
    BasePortfolioHelperService.constructInitialAdditionalFieldsToLoad = function (config, typeConfig) {
        var additionalFieldsToLoad = new Set();
        if (typeConfig) {
            if (typeConfig.type && typeConfig.type.field) {
                if (config.fields.map(function (field) { return field.fieldName; }).indexOf(typeConfig.type.field) === -1) {
                    additionalFieldsToLoad.add(typeConfig.type.field);
                }
            }
            if (typeConfig.subType && typeConfig.subType.field) {
                if (config.fields.map(function (field) { return field.fieldName; }).indexOf(typeConfig.subType.field) === -1) {
                    additionalFieldsToLoad.add(typeConfig.subType.field);
                }
            }
        }
        return additionalFieldsToLoad;
    };
    BasePortfolioHelperService.constructPortfolioConfigModel = function (category, config, filterFields, indexedFields, additionalFieldsToLoad, columnsModels, defaultFilter) {
        var portfolioConfig = new base_portfolio_constructed_portfolio_model_1.BasePortfolioConstructedPortfolioModel();
        var defaultSortingField = config.defaultSortingField && indexedFields.indexOf(config.defaultSortingField) !== -1
            ? config.defaultSortingField : undefined;
        var quickFilterField = config.quickFilterField && indexedFields.indexOf(config.quickFilterField) !== -1
            ? config.quickFilterField : undefined;
        portfolioConfig.externalFilters = config.externalFilters;
        portfolioConfig.filter = new idm_portfolio_control_1.PortfolioFilterModel(category, filterFields, {});
        portfolioConfig.searchFilter = new idm_portfolio_control_1.SearchFilterModel(category);
        portfolioConfig.quickFilter = quickFilterField ? new idm_portfolio_control_1.QuickFilterModel(category, config.quickFilterField) : undefined;
        portfolioConfig.portfolioConfig = new idm_portfolio_control_1.PortfolioConfigModel(category, BasePortfolioHelperService_1.BASE_PORTFOLIO_PAGE_SIZE, columnsModels, null, null, defaultFilter, false, [], false, null, defaultSortingField, config.sortingDirection, BasePortfolioHelperService_1.BASE_PORTFOLIO_ITEMS_NUMBER_PER_PAGE, null, [idm_um_permission_client_js_1.CategoryPermissionType.VIEW], Array.from(additionalFieldsToLoad));
        return portfolioConfig;
    };
    // ToDo: add bulk actions support;
    /**
     * Constructs {@link BasePortfolioConstructedPortfolioModel} for given configurations.
     */
    BasePortfolioHelperService.prototype.constructBasePortfolio = function (config, category, rootCategory, defaultFilter) {
        var _this = this;
        var customFields$ = this.getCustomFields(config, category, rootCategory);
        var customComponents$ = this.getCustomComponents(config, category, rootCategory);
        var customAggregateFunctions$ = this.getCustomAggregateFunctions(config, category, rootCategory);
        var additionalFieldsToLoad$ = this.getAdditionalFieldsToLoad(config, category);
        var indexedFields$ = this.constructCategoryIndexedFields(category).pipe(operators_1.shareReplay(1));
        var filterFields$ = indexedFields$.pipe(operators_1.switchMap(function (indexedFields) {
            return _this.constructPortfolioFilterFields(category, config.filterFields, indexedFields);
        }));
        return zip_1.zip(customFields$, customComponents$, customAggregateFunctions$, filterFields$, additionalFieldsToLoad$, indexedFields$)
            .pipe(operators_1.switchMap(function (_a) {
            var customFields = _a[0], customComponents = _a[1], customAggregateFunctions = _a[2], filterFields = _a[3], additionalFieldsToLoad = _a[4], indexedFields = _a[5];
            return _this.constructPortfolioColumnModels(category, rootCategory, config, customFields, customComponents, customAggregateFunctions, indexedFields, additionalFieldsToLoad)
                .pipe(operators_1.map(function (columnsModels) {
                return [filterFields, additionalFieldsToLoad, indexedFields, columnsModels];
            }));
        }), operators_1.map(function (_a) {
            var filterFields = _a[0], additionalFieldsToLoad = _a[1], indexedFields = _a[2], columnsModels = _a[3];
            return BasePortfolioHelperService_1.constructPortfolioConfigModel(category, config, filterFields, indexedFields, additionalFieldsToLoad, columnsModels, defaultFilter);
        }));
    };
    BasePortfolioHelperService.prototype.generateDefaultFilter = function (rootCategoryId, rootEntityId, categoryId, portfolioDefinition) {
        var _this = this;
        if (!rootEntityId || categoryId === rootCategoryId) {
            return of_1.of(this.getBasicPortfolioFilterFilter(portfolioDefinition));
        }
        return this.rootCategoryProviderService.getRootCategoryMetaField(categoryId).pipe(operators_1.map(function (lookupToRootField) {
            if (lookupToRootField) {
                var filterBuilder = new idm_de_core_frontend_1.FilterBuilder().is(lookupToRootField.getSystemName(), rootEntityId);
                return new idm_portfolio_control_1.PortfolioFilterDto(_this.getFilterCriteria(filterBuilder, portfolioDefinition), null);
            }
            return _this.getBasicPortfolioFilterFilter(portfolioDefinition);
        }));
    };
    BasePortfolioHelperService.prototype.getCustomFields = function (config, category, rootCategory) {
        return this.portfolioDefinitionCustomValuesService && config.fields
            .find(function (field) { return field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.CALCULATION; }) ?
            this.portfolioDefinitionCustomValuesService.getCustomFields(category, rootCategory) : of_1.of([]);
    };
    BasePortfolioHelperService.prototype.getCustomComponents = function (config, category, rootCategory) {
        return this.portfolioDefinitionCustomValuesService && config.fields
            .find(function (field) { return field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT; }) ?
            this.portfolioDefinitionCustomValuesService.getCustomComponents(category, rootCategory) : of_1.of([]);
    };
    BasePortfolioHelperService.prototype.getCustomAggregateFunctions = function (config, category, rootCategory) {
        return this.customAggregateFunctionsProviderService && config.fields
            .find(function (field) { return field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE; }) ?
            this.customAggregateFunctionsProviderService.getCustomAggregateFunctions(category, rootCategory) : of_1.of([]);
    };
    BasePortfolioHelperService.prototype.getAdditionalFieldsToLoad = function (config, category) {
        return this.typeConfigurationService.getTypedCategoryProperties(category)
            .pipe(operators_1.map(function (entityTypeConfigs) {
            return BasePortfolioHelperService_1.constructInitialAdditionalFieldsToLoad(config, entityTypeConfigs);
        }));
    };
    BasePortfolioHelperService.prototype.getBasicPortfolioFilterFilter = function (portfolioDefinition) {
        var filterCriteria = portfolioDefinition && portfolioDefinition.defaultFilterJson
            ? this.getFilterCriteria(new idm_de_core_frontend_1.FilterBuilder(), portfolioDefinition) : null;
        return filterCriteria ? new idm_portfolio_control_1.PortfolioFilterDto(filterCriteria, null) : null;
    };
    BasePortfolioHelperService.prototype.getFilterCriteria = function (filterBuilder, portfolioDefinition) {
        var filterCriteria = filterBuilder.build();
        if (portfolioDefinition && portfolioDefinition.defaultFilterJson) {
            var filterJson_1 = filterCriteria.toJson();
            filterCriteria.toJson = function () {
                return Object.keys(filterJson_1).length ?
                    { '$and': [filterJson_1, portfolioDefinition.defaultFilterJson] }
                    : portfolioDefinition.defaultFilterJson;
            };
        }
        return filterCriteria;
    };
    BasePortfolioHelperService.prototype.constructCategoryIndexedFields = function (category) {
        return this.kbService.getMetaCategoryByMetaCategoryId(new idm_kb_service_client_js_1.MetaCategoryId(category))
            .pipe(operators_1.map(function (metaCategory) {
            return metaCategory.getSearchableFieldIds().map(function (value) { return value.getSystemName(); });
        }));
    };
    BasePortfolioHelperService.prototype.constructPortfolioFilterFields = function (category, configFilterFields, indexedFields) {
        var customFilterKeyFieldValueMap$ = this.getCustomFilterFields(configFilterFields, category);
        return customFilterKeyFieldValueMap$.pipe(operators_1.map(function (customFilterKeyFieldValueMap) {
            var filterFields = [];
            configFilterFields.forEach(function (filterField) {
                var filterFieldLevels;
                if (typeof filterField === 'string') {
                    filterFieldLevels = filterField.split('.');
                    if (indexedFields.indexOf(filterFieldLevels[0]) !== -1) {
                        filterFields.push(filterField);
                    }
                    else if (customFilterKeyFieldValueMap.has(filterField)) {
                        filterFields.push(customFilterKeyFieldValueMap.get(filterField));
                    }
                }
                else {
                    if (Object.keys(filterField).some(function (key) { return indexedFields.indexOf(key) !== -1; })) {
                        filterFields.push(filterField);
                    }
                }
            });
            return filterFields;
        }));
    };
    BasePortfolioHelperService.prototype.getCustomFilterFields = function (filterFields, category) {
        var _this = this;
        var customFilterKeyFilterMap = new Map();
        var customFilterFields$ = this.basePortfolioCustomFilterPropertiesService ?
            this.basePortfolioCustomFilterPropertiesService.getCustomFilterKeys(category).pipe(operators_1.switchMap(function (filterFieldKeys) {
                var filterFieldsToLoad$ = [];
                filterFields.forEach(function (filterField) {
                    if (filterFieldKeys.indexOf(filterField) !== -1) {
                        filterFieldsToLoad$.push(_this.basePortfolioCustomFilterPropertiesService.getCustomFilterField(filterField, category)
                            .pipe(operators_1.tap(function (customFilter) { return customFilter && customFilterKeyFilterMap.set(filterField, customFilter); })));
                    }
                });
                return filterFieldsToLoad$.length ? Observable_1.Observable.zip.apply(Observable_1.Observable, filterFieldsToLoad$) : of_1.of([]);
            }))
            : of_1.of([]);
        return customFilterFields$.pipe(operators_1.map(function () { return customFilterKeyFilterMap; }));
    };
    // ToDo: set universal message to portfolio constructed from configs - for cases when no entity created
    BasePortfolioHelperService.prototype.constructPortfolioColumnModels = function (category, rootCategory, config, customFields, customComponents, customAggregateFunctions, indexedFields, additionalFieldsToLoad) {
        var _this = this;
        var columns = [];
        config.fields.forEach(function (field) {
            if (field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.COMPONENT) {
                var customComponent = customComponents.find(function (c) { return c.componentSelector === field.fieldName; });
                if (customComponent) {
                    _this.addParticipants(customComponent, additionalFieldsToLoad);
                    _this.addComponentFieldColumn(columns, field, customComponent);
                }
            }
            else if (field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.CALCULATION) {
                var customFunction = customFields.find(function (customCalculation) { return customCalculation.key === field.fieldName; });
                if (customFunction) {
                    _this.addParticipants(customFunction, additionalFieldsToLoad);
                    _this.addCalculationFieldColumn(columns, field, category, rootCategory);
                }
            }
            else if (field.overviewPortfolioFieldType === overview_field_type_1.OverviewPortfolioFieldType.AGGREGATE) {
                var customAggregate = customAggregateFunctions.find(function (func) { return func.key === field.fieldName; });
                if (customAggregate && field.aggregateConfig.sourceField) {
                    _this.addParticipants({ participants: [field.aggregateConfig.sourceField] }, additionalFieldsToLoad);
                    _this.addAggregateFieldColumn(columns, field, category, rootCategory);
                }
            }
            else if (indexedFields.indexOf(field.fieldName) !== -1) {
                columns.push(new portfolio_column_model_1.PortfolioColumnModel(column_type_1.ColumnType.FIELD, field.fieldName));
            }
        });
        return of_1.of(columns);
    };
    BasePortfolioHelperService.prototype.addParticipants = function (obj, additionalFieldsToLoad) {
        obj.participants &&
            obj.participants.forEach(function (participant) { return additionalFieldsToLoad.add(participant); });
    };
    BasePortfolioHelperService.prototype.addComponentFieldColumn = function (columns, field, customComponent) {
        var templateSubject = new ReplaySubject_1.ReplaySubject();
        templateSubject['customComponentProperties'] = {
            componentSelector: field.fieldName,
            moduleLoaderFunction: customComponent.moduleLoaderFunction,
            component: customComponent.component,
            componentInputs: customComponent.componentInputs
        };
        /**
         * TODO: Change column type to {@link ColumnType.COMPONENT}.
         * (as for now providing module path as string does not work for portfolio's component fields)
         * */
        columns.push(new portfolio_column_model_1.PortfolioColumnModel(column_type_1.ColumnType.TEMPLATE, field.fieldName, null, null, null, null, templateSubject, customComponent.title));
    };
    BasePortfolioHelperService.prototype.addCalculationFieldColumn = function (columns, field, category, rootCategory) {
        var _this = this;
        var column = new portfolio_column_model_1.PortfolioColumnModel(column_type_1.ColumnType.FUNCTION, field.fieldName, null, null, null, null, null, field.fieldName);
        column.externalFunction = function (mainEntity) {
            return _this.portfolioDefinitionCustomValuesService.calculate(field.fieldName, category, mainEntity, rootCategory);
        };
        columns.push(column);
    };
    BasePortfolioHelperService.prototype.addAggregateFieldColumn = function (columns, field, category, rootCategory) {
        var _this = this;
        var column = new portfolio_column_model_1.PortfolioColumnModel(column_type_1.ColumnType.FUNCTION, field.fieldName, null, null, null, null, null, custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService.getDefaultTitle(field.fieldName, category, field.aggregateConfig, null));
        column.externalFunction = function (mainEntity) {
            return _this.constructAggregateFieldByConfigs(mainEntity, field, category, rootCategory);
        };
        columns.push(column);
    };
    BasePortfolioHelperService.prototype.constructAggregateFieldByConfigs = function (mainEntity, field, category, rootCategory) {
        var _this = this;
        var sourceField = mainEntity && mainEntity.getProperty(field.aggregateConfig.sourceField).value || [];
        var aggregateFilter$ = this.customAggregateFilteringProviderService && field.aggregateConfig.customFilter ?
            this.customAggregateFilteringProviderService.filter(field.aggregateConfig.customFilter, category, rootCategory, sourceField, field.aggregateConfig)
            : of_1.of(sourceField);
        aggregateFilter$ = aggregateFilter$.pipe(operators_1.map(function (result) {
            var entityToLoadFrom;
            if (field.aggregateConfig.aggregateField) {
                entityToLoadFrom = result.map(function (entity) { return entity.getProperty(field.aggregateConfig.aggregateField).value; });
            }
            else {
                entityToLoadFrom = result;
            }
            return entityToLoadFrom;
        }));
        return aggregateFilter$.pipe(operators_1.switchMap(function (result) {
            return _this.customAggregateFunctionsProviderService.calculate(field.fieldName, category, rootCategory, result, field.aggregateConfig, null);
        }), operators_1.map(function (result) {
            return result.value;
        }));
    };
    var BasePortfolioHelperService_1;
    BasePortfolioHelperService.BASE_PORTFOLIO_PAGE_SIZE = 10;
    BasePortfolioHelperService.BASE_PORTFOLIO_ITEMS_NUMBER_PER_PAGE = [10, 20, 40];
    BasePortfolioHelperService = BasePortfolioHelperService_1 = __decorate([
        core_1.Injectable(),
        __param(0, core_1.Optional()),
        __param(1, core_1.Optional()),
        __param(2, core_1.Optional()),
        __param(3, core_1.Optional()),
        __metadata("design:paramtypes", [portfolio_definition_custom_values_service_1.PortfolioDefinitionCustomValuesService,
            custom_aggregate_functions_provider_service_1.CustomAggregateFunctionsProviderService,
            custom_aggregate_filtering_provider_service_1.CustomAggregateFilteringProviderService,
            base_portfolio_custom_filter_properties_service_1.BasePortfolioCustomFilterPropertiesService,
            root_category_provider_service_1.RootCategoryProviderService,
            type_configuration_service_1.TypeConfigurationService,
            idm_kb_service_client_js_1.KbService])
    ], BasePortfolioHelperService);
    return BasePortfolioHelperService;
}());
exports.BasePortfolioHelperService = BasePortfolioHelperService;
//# sourceMappingURL=base-portfolio-helper.service.js.map